// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/app_icons.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SrcSet } from "./images";
/**
 * @generated from protobuf message c1.api.assets.v1.AppIcon
 */
export interface AppIcon {
    /**
     * @generated from protobuf field: c1.api.assets.v1.AppIconRef app_icon = 1
     */
    appIcon?: AppIconRef;
    /**
     * @generated from protobuf field: string src = 2
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 3
     */
    srcSet?: SrcSet;
}
/**
 * @generated from protobuf message c1.api.assets.v1.AppIconRef
 */
export interface AppIconRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetAppIconRequest
 */
export interface GetAppIconRequest {
    /**
     * @generated from protobuf field: c1.api.assets.v1.AppIconRef app_icon_ref = 1
     */
    appIconRef?: AppIconRef;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetAppIconResponse
 */
export interface GetAppIconResponse {
    /**
     * @generated from protobuf field: c1.api.assets.v1.AppIcon app_icon = 1
     */
    appIcon?: AppIcon;
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetAppIconsRequest
 */
export interface BulkGetAppIconsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.AppIconRef app_icons = 1
     */
    appIcons: AppIconRef[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetAppIconsResponse
 */
export interface BulkGetAppIconsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.AppIcon list = 1
     */
    list: AppIcon[];
}
// @generated message type with reflection information, may provide speed optimized methods
class AppIcon$Type extends MessageType<AppIcon> {
    constructor() {
        super("c1.api.assets.v1.AppIcon", [
            { no: 1, name: "app_icon", kind: "message", T: () => AppIconRef },
            { no: 2, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
    create(value?: PartialMessage<AppIcon>): AppIcon {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.src = "";
        if (value !== undefined)
            reflectionMergePartial<AppIcon>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppIcon): AppIcon {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.assets.v1.AppIconRef app_icon */ 1:
                    message.appIcon = AppIconRef.internalBinaryRead(reader, reader.uint32(), options, message.appIcon);
                    break;
                case /* string src */ 2:
                    message.src = reader.string();
                    break;
                case /* c1.api.assets.v1.SrcSet src_set */ 3:
                    message.srcSet = SrcSet.internalBinaryRead(reader, reader.uint32(), options, message.srcSet);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppIcon, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.assets.v1.AppIconRef app_icon = 1; */
        if (message.appIcon)
            AppIconRef.internalBinaryWrite(message.appIcon, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string src = 2; */
        if (message.src !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.src);
        /* c1.api.assets.v1.SrcSet src_set = 3; */
        if (message.srcSet)
            SrcSet.internalBinaryWrite(message.srcSet, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.AppIcon
 */
export const AppIcon = new AppIcon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppIconRef$Type extends MessageType<AppIconRef> {
    constructor() {
        super("c1.api.assets.v1.AppIconRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppIconRef>): AppIconRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AppIconRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppIconRef): AppIconRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppIconRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.AppIconRef
 */
export const AppIconRef = new AppIconRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppIconRequest$Type extends MessageType<GetAppIconRequest> {
    constructor() {
        super("c1.api.assets.v1.GetAppIconRequest", [
            { no: 1, name: "app_icon_ref", kind: "message", T: () => AppIconRef }
        ]);
    }
    create(value?: PartialMessage<GetAppIconRequest>): GetAppIconRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAppIconRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppIconRequest): GetAppIconRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.assets.v1.AppIconRef app_icon_ref */ 1:
                    message.appIconRef = AppIconRef.internalBinaryRead(reader, reader.uint32(), options, message.appIconRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppIconRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.assets.v1.AppIconRef app_icon_ref = 1; */
        if (message.appIconRef)
            AppIconRef.internalBinaryWrite(message.appIconRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetAppIconRequest
 */
export const GetAppIconRequest = new GetAppIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppIconResponse$Type extends MessageType<GetAppIconResponse> {
    constructor() {
        super("c1.api.assets.v1.GetAppIconResponse", [
            { no: 1, name: "app_icon", kind: "message", T: () => AppIcon }
        ]);
    }
    create(value?: PartialMessage<GetAppIconResponse>): GetAppIconResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAppIconResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppIconResponse): GetAppIconResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.assets.v1.AppIcon app_icon */ 1:
                    message.appIcon = AppIcon.internalBinaryRead(reader, reader.uint32(), options, message.appIcon);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppIconResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.assets.v1.AppIcon app_icon = 1; */
        if (message.appIcon)
            AppIcon.internalBinaryWrite(message.appIcon, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetAppIconResponse
 */
export const GetAppIconResponse = new GetAppIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppIconsRequest$Type extends MessageType<BulkGetAppIconsRequest> {
    constructor() {
        super("c1.api.assets.v1.BulkGetAppIconsRequest", [
            { no: 1, name: "app_icons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppIconRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkGetAppIconsRequest>): BulkGetAppIconsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appIcons = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetAppIconsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetAppIconsRequest): BulkGetAppIconsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.assets.v1.AppIconRef app_icons */ 1:
                    message.appIcons.push(AppIconRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetAppIconsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.assets.v1.AppIconRef app_icons = 1; */
        for (let i = 0; i < message.appIcons.length; i++)
            AppIconRef.internalBinaryWrite(message.appIcons[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetAppIconsRequest
 */
export const BulkGetAppIconsRequest = new BulkGetAppIconsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppIconsResponse$Type extends MessageType<BulkGetAppIconsResponse> {
    constructor() {
        super("c1.api.assets.v1.BulkGetAppIconsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppIcon }
        ]);
    }
    create(value?: PartialMessage<BulkGetAppIconsResponse>): BulkGetAppIconsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetAppIconsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetAppIconsResponse): BulkGetAppIconsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.assets.v1.AppIcon list */ 1:
                    message.list.push(AppIcon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetAppIconsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.assets.v1.AppIcon list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppIcon.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetAppIconsResponse
 */
export const BulkGetAppIconsResponse = new BulkGetAppIconsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.assets.v1.AppIconService
 */
export const AppIconService = new ServiceType("c1.api.assets.v1.AppIconService", [
    { name: "GetAppIcon", options: { "authz.method": { role: "VIEWER" } }, I: GetAppIconRequest, O: GetAppIconResponse },
    { name: "BulkGetAppIcons", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetAppIconsRequest, O: BulkGetAppIconsResponse }
]);
